var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStatus = function SvgStatus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.455c0 .8-.655 1.454-1.455 1.454a1.236 1.236 0 0 1-.37-.05l-2.59 2.581a1.459 1.459 0 0 1-1.404 1.833A1.459 1.459 0 0 1 8.779 5.44L6.924 3.585c-.117.037-.248.051-.379.051-.13 0-.261-.014-.378-.05L2.858 6.901c.037.116.051.24.051.37 0 .8-.654 1.455-1.454 1.455C.655 8.727 0 8.073 0 7.273c0-.8.655-1.455 1.455-1.455.13 0 .254.015.37.051L5.142 2.56A1.459 1.459 0 0 1 6.546.727 1.459 1.459 0 0 1 7.948 2.56l1.855 1.855c.116-.037.247-.051.378-.051.13 0 .262.014.378.05l2.582-2.589a1.236 1.236 0 0 1-.051-.37c0-.8.654-1.455 1.454-1.455.8 0 1.455.655 1.455 1.455Z",
    fill: "#90A9C0",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status.660ac4e6.svg";
export { ForwardRef as ReactComponent };